import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Booking from "./pages/Booking";
import Success from "./pages/Success";
import ConfirmedBooking from "./pages/ConfirmedBooking";
import { FunnelConfigProvider } from "./hooks/use-funnel-config";
import { wealthPlanConfig } from "./config/funnel-config";

function App() {
  return (
    <FunnelConfigProvider config={wealthPlanConfig}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/success" element={<Success />} />
          <Route path="/confirmed-booking" element={<ConfirmedBooking />} />
        </Routes>
      </BrowserRouter>
    </FunnelConfigProvider>
  );
}

export default App;
